import { render } from "./Complete.vue?vue&type=template&id=be8ba0f2&scoped=true"
import script from "./Complete.vue?vue&type=script&lang=js"
export * from "./Complete.vue?vue&type=script&lang=js"

import "./Complete.vue?vue&type=style&index=0&id=be8ba0f2&scoped=true&lang=css"
import "./Complete.vue?vue&type=style&index=1&id=be8ba0f2&lang=css"

import exportComponent from "C:\\wamp64\\www\\ehaat-ambulance-game\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be8ba0f2"]])

export default __exports__